module.exports = __webpack_public_path__ + "img/4fff3bd17ad9f86b9e48b8766526b3ad.png";